export const featureConfig = {
  APP: {},
  EI: {},
  AI: {
    trends: {
      sections: {
        summary: false,
      },
    },
  },
  ODP: {
    trends: {
      sections: {
        summary: false,
        diagnostics: true,
        dimensions: true,
      },
      toggles: {
        'manual-alerts': false,
        'ai-alerts': false,
        annotations: false,
        dod: true,
      },
      actions: {
        share: false,
        save: false,
        export: true,
        'make-default': false,
      },
      base: {
        'live-mode': false,
        filter_popup: false,
        compare: true,
      },
    },
    common: {
      kpi: false,
      'header-context-id': true,
    },
  },
};
